import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '@/i18n/i18n'
import emap_module from './emap_module.js'
import atlas_module from './atlas_module.js';
import monitor_module from './monitor_module.js'
import emap_monitor_module from './emap-monitor_module.js'
import case_module from './case_module.js'
import favorites_module from './favorites_module.js'

import { UNITS_PUB } from '../config/config'

Vue.use(Vuex)

export default new Vuex.Store({
    namespaced: true,
    modules: {
        emap: emap_module,
        atlas: atlas_module,
        monitor: monitor_module,
        case: case_module,
        'emap-monitor': emap_monitor_module,
        favorites: favorites_module
    },
    state: {
        user:'',
        client_name: '',  // for ajax
        language: '',
        i18n_language: '',

        is_short_term_precp_occur: false,
        display_block_width: null,

        width: window.innerWidth,
        height: window.innerHeight,
    },
    mutations:{
        SET_USERNAME (state, username) {
            state.user = username;
        },
        
        set_client_name(state, client_name) {
            state.client_name = client_name;
        },
        
        set_language(state, new_language) {
            state.language = new_language;
        },

        set_i18n_language(state, new_i18n_language) {
            state.i18n_language = new_i18n_language;
            i18n.locale = new_i18n_language;
        },

        set_short_term_precp_occur(state, status) {
            state.is_short_term_precp_occur = status;
        },

        set_display_block_width(state, display_block_width) {
            state.display_block_width = display_block_width;
        },

        set_window_boundary(state, { width, height }) {
            state.width = width;
            state.height = height;
        }
    },
    actions: {
        set_username(context, payload) {
            context.commit('SET_USERNAME', payload);
        },
    },
    getters: {
        user: state => {
            return state.user;
        },      

        client_name: state => {
            return state.client_name;
        },

        group_name: state => {
            let client_name = state.client_name

            if (UNITS_PUB.includes(client_name)) {
                return 'Guest'
            }
            
            return client_name
        },

        logo_file_name: state => {
            if (UNITS_PUB.includes(state.client_name)) {
                return 'QPlus'
            }

            return 'QpePlus'
        },

        // 不確定未來會不會變成兩個功能，寫成兩個變數
        is_activate_i18n: state => {
            return UNITS_PUB.includes(state.client_name)
        },

        is_pub: state => {
            return UNITS_PUB.includes(state.client_name)
        },

        api_language_parameters: state => {
            return {
                params: {
                    lang: state.language
                }
            }
        },

        is_mobile_width: ({ width }) => {
            return width < 769;
        },

        is_pad_width: ({ width }) => {
            return width < 1025;
        },

        is_insufficient_height: ({ height }) => {
            return height < 710
        }
    },
})
